<div class="form-field" [formGroup]="formGroup">
  <label class="input-label" [id]="controlConfig.name + '-label'" [attr.for]="controlConfig.name">
    <span class="label-text">
      {{ controlConfig.label }}
      <span *ngIf="controlConfig.required">*</span>
    </span>

    <span class="info-icon" *ngIf="controlConfig.icon" aria-hidden="true">
      <svg-icon [src]="'assets/images/icons/' + controlConfig.icon + '.svg'"></svg-icon>
    </span>
  </label>

  <div class="select-container">
    <button
      #selectButton
      type="button"
      role="combobox"
      [attr.id]="controlConfig.name"
      [attr.aria-controls]="controlConfig.name + '-listbox'"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-expanded]="isDropdownOpen"
      [attr.aria-required]="controlConfig.required"
      [attr.aria-invalid]="isInvalid"
      [attr.aria-describedby]="controlConfig.name + '-error' + ' ' + controlConfig.name + '-success'"
      [class.error]="isInvalid"
      [class.valid]="isValid"
      [class.disabled]="controlConfig.disabled"
      [class.open]="isDropdownOpen"
      (click)="toggleDropdown($event)">
      {{ selectedOption || placeholder }}
      <span class="dropdown-icon" aria-hidden="true"></span>
    </button>

    <div class="validation-icon" *ngIf="isInvalid || isValid">
      <svg-icon *ngIf="isInvalid" [src]="'assets/images/icons/error.svg'" class="error-icon" aria-hidden="true"></svg-icon>
      <svg-icon *ngIf="isValid" [src]="'assets/images/icons/success.svg'" class="success-icon" aria-hidden="true"></svg-icon>
    </div>

    <ul #listbox role="listbox" [id]="controlConfig.name + '-listbox'" [class.active]="isDropdownOpen" tabindex="-1">
      @for (option of controlConfig.options; track option.value; let i = $index) {
        <li
          role="option"
          [id]="controlConfig.name + '-option-' + i"
          [attr.aria-selected]="formGroup.get(controlConfig.name)?.value === option.value"
          [class.active]="formGroup.get(controlConfig.name)?.value === option.value"
          [class.current]="i === currentOptionIndex"
          (click)="selectOption(option, $event)">
          {{ option.label }}
        </li>
      }
    </ul>
  </div>

  <div [id]="controlConfig.name + '-error'" aria-live="assertive">
    <span class="error-message" *ngIf="errorMessage">
      <span class="sr-only">Fehler</span>
      {{ errorMessage }}
    </span>
  </div>

  <div [id]="controlConfig.name + '-success'" aria-live="assertive">
    <span class="sr-only" *ngIf="isValid">Eingabe gültig</span>
  </div>
</div>
